module.exports = __webpack_public_path__ + "img/slogan.6c1c3523.png";